<div class="popup">
  <div class="content">
    <div class="top">
      <h3 class="title">{{ translation.wayfinding.sameStartAsTargetTitle | transloco }}</h3>
    </div>

    <div class="inner-content">
      <p class="subtitle">
        <cue-icon [icon]="ICONS.cueExclamation" class="k-mr-2 icon" />
        {{ translation.wayfinding.sameStartAsTarget | transloco }}
      </p>
      <p>{{ translation.wayfinding.sameStartAsTargetAsk | transloco }}</p>
    </div>

    <div class="buttons flex justify-between">
      @if (!canChangeOnlyTarget()) {
        <button cue-button size="small" [link]="primary() !== 'start'" (click)="changeStart.emit()">
          <cue-icon [icon]="ICONS.cueStart" />
          {{ translation.navigation.changeStart | transloco }}
        </button>
      }
      <button
        cue-button
        size="small"
        [link]="!canChangeOnlyTarget() && primary() !== 'target'"
        (click)="changeTarget.emit()"
      >
        <cue-icon [icon]="ICONS.cueTarget" />
        {{ translation.navigation.changeTarget | transloco }}
      </button>
    </div>
  </div>
</div>
